import { type ApiClientResponse, apiClient, routes } from 'common/services';

type ChangePasswordRequest = {
  body: ChangePasswordRequestBody;
};

type ChangePasswordRequestBody = {
  user: {
    // eslint-disable-next-line @typescript-eslint/naming-convention -- Keys are defined by Backend API endpoint
    current_password: string;
    password: string;
  };
};

export const changePassword = async ({ body }: ChangePasswordRequest) =>
  apiClient.post<unknown, ApiClientResponse<unknown>>(routes.user.updatePassword, body);
